import { Button, Modal, Spinner } from "react-bootstrap";
import { ReactElement } from 'react';

interface Action {
    title: string;
    isLoading: boolean;
    variant: string;
    href?: string;
    onClickHandler: CallableFunction;
}

interface Props {
    title: string;
    description: string;
    icon: ReactElement;
    actions: Action[];
}

export default function GenericModal({ title, description, icon, actions }: Props) {
    return <Modal size="lg" fullscreen={true} show={true}>
        <div className="container mw-95">
            <div className="row">
                <div
                    className="col-lg-12 shadow-lg d-flex align-items-center rounded-3 rounded-start-0 "
                    style={{
                        backgroundColor: "var(--bg-1)",
                        borderRadius: 10,
                    }}
                >
                    <div className="container my-auto text-center py-4 pd-l-10 pd-r-10">
                        {icon}
                        <h2 className="text-black">{title}</h2>
                        <p className="tx-14">
                            {description}
                        </p>

                        {
                            actions.map((action, i) => {
                                const { isLoading, title, onClickHandler, variant, href } = action;

                                return <div className="centered-flex mg-t-10" key={i}>
                                    <Button className="rounded-button" variant={variant} href={href}
                                        style={{ cursor: isLoading ? "not-allowed" : 'pointer' }} onClick={(e) => {
                                            if (!isLoading) {
                                                e.preventDefault();

                                                return onClickHandler();
                                            }
                                        }} type="button">
                                        {isLoading ? <Spinner animation="border" size="sm" /> : title}
                                    </Button>
                                </div>
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    </Modal >
}